<template>
    <form-group
            :name="name"
            :label="label"
            :help-text="helpText"
            :error="error"
            :label-width="labelWidth"
            :input-width="inputWidth"
    >
        <date-widget 
                :name="name" 
                :label="label"
                :value="value"
                :parameters="parameters"
                :format="format"
                :original-format="originalFormat"
                :disabled="disabled"
                @input="$emit('input', $event)"
        ></date-widget>
    </form-group>
</template>

<script>
    import DateWidget from "../Widgets/Date";
    import FormGroup from "./FormGroup";

    export default {
        components: {DateWidget, FormGroup},

        props: {
            name: {
                required: false,
                type: String
            },

            label: {
                required: false,
                type: String
            },

            helpText: {
                required: false,
                type: String,
                default: null
            },

            value: {
                required: true
            },

            error: {
                required: false,
                type: String
            },

            labelWidth: {
                required: false,
                type: Number
            },

            inputWidth: {
                required: false,
                type: Number
            },

            parameters: {
                required:false,
                type:Object,
                default() {
                    return {}
                }
            },

            disabled: {
                required: false,
                type: Boolean,
                default: false
            },

            format: {
                required: false,
                type: String,
                default: 'YYYY-MM-DD'
            },

            originalFormat: {
                required: false,
                type: String,
                default: 'YYYY-MM-DD'
            }
        }
    }
</script>
